export default [
  { code: "&#x7B;", value: "{" },
  { code: "&#x7C;", value: "|" },
  { code: "&#x7D;", value: "}" },
  { code: "&#x7e;", value: "~" },
  { code: "&#xA0;", value: " " },
  { code: "&#xA1;", value: "¡" },
  { code: "&#xA2;", value: "¢" },
  { code: "&#xA3;", value: "£" },
  { code: "&#xA4;", value: "¤" },
  { code: "&#xA5;", value: "¥" },
  { code: "&#xA6;", value: "¦" },
  { code: "&#xA7;", value: "§" },
  { code: "&#xA8;", value: "¨" },
  { code: "&#xA9;", value: "©" },
  { code: "&#xAA;", value: "ª" },
  { code: "&#xAB;", value: "«" },
  { code: "&#xAC;", value: "¬" },
  { code: "&#xAD;", value: "®" },
  { code: "&#xAF;", value: "¯" },
  { code: "&#xB0;", value: "°" },
  { code: "&#xB1;", value: "±" },
  { code: "&#xB2;", value: "²" },
  { code: "&#xB3;", value: "³" },
  { code: "&#xB4;", value: "´" },
  { code: "&#xB5;", value: "µ" },
  { code: "&#xB6;", value: "¶" },
  { code: "&#xB7;", value: "·" },
  { code: "&#xB8;", value: "¸" },
  { code: "&#xB9;", value: "¹" },
  { code: "&#xBA;", value: "º" },
  { code: "&#xBB;", value: "»" },
  { code: "&#xBC;", value: "¼" },
  { code: "&#xBD;", value: "½" },
  { code: "&#xBE;", value: "¾" },
  { code: "&#xBF;", value: "¿" },
  { code: "&#xC0;", value: "À" },
  { code: "&#xC1;", value: "Á" },
  { code: "&#xC2;", value: "Â" },
  { code: "&#xC3;", value: "Ã" },
  { code: "&#xC4;", value: "Ä" },
  { code: "&#xC5;", value: "Å" },
  { code: "&#xC6;", value: "Æ" },
  { code: "&#xC7;", value: "Ç" },
  { code: "&#xC8;", value: "È" },
  { code: "&#xC9;", value: "É" },
  { code: "&#xCA;", value: "Ê" },
  { code: "&#xCB;", value: "Ë" },
  { code: "&#xCC;", value: "Ì" },
  { code: "&#xCD;", value: "Í" },
  { code: "&#xCE;", value: "Î" },
  { code: "&#xCF;", value: "Ï" },
  { code: "&#xD0;", value: "Ð" },
  { code: "&#xD1;", value: "Ñ" },
  { code: "&#xD2;", value: "Ò" },
  { code: "&#xD3;", value: "Ó" },
  { code: "&#xD4;", value: "Ô" },
  { code: "&#xD5;", value: "Õ" },
  { code: "&#xD6;", value: "Ö" },
  { code: "&#xD7;", value: "×" },
  { code: "&#xD8;", value: "Ø" },
  { code: "&#xD9;", value: "Ù" },
  { code: "&#xDA;", value: "Ú" },
  { code: "&#xDB;", value: "Û" },
  { code: "&#xDC;", value: "Ü" },
  { code: "&#xDD;", value: "Ý" },
  { code: "&#xDE;", value: "Þ" },
  { code: "&#xDF;", value: "ß" },
  { code: "&#xE0;", value: "à" },
  { code: "&#xE1;", value: "á" },
  { code: "&#xE2;", value: "â" },
  { code: "&#xE3;", value: "ã" },
  { code: "&#xE4;", value: "ä" },
  { code: "&#xE5;", value: "å" },
  { code: "&#xE6;", value: "æ" },
  { code: "&#xE7;", value: "ç" },
  { code: "&#xE8;", value: "è" },
  { code: "&#xE9;", value: "é" },
  { code: "&#xEA;", value: "ê" },
  { code: "&#xEB;", value: "ë" },
  { code: "&#xEC;", value: "ì" },
  { code: "&#xED;", value: "í" },
  { code: "&#xEE;", value: "î" },
  { code: "&#xEF;", value: "ï" },
  { code: "&#xF0;", value: "ð" },
  { code: "&#xF1;", value: "ñ" },
  { code: "&#xF2;", value: "ò" },
  { code: "&#xF3;", value: "ó" },
  { code: "&#xF4;", value: "ô" },
  { code: "&#xF5;", value: "õ" },
  { code: "&#xF6;", value: "ö" },
  { code: "&#xF7;", value: "÷" },
  { code: "&#xF8;", value: "ø" },
  { code: "&#xF9;", value: "ù" },
  { code: "&#xFA;", value: "ú" },
  { code: "&#xFB;", value: "û" },
  { code: "&#xFC;", value: "ü" },
  { code: "&#xFD;", value: "ý" },
  { code: "&#xFE;", value: "þ" },
  { code: "&#xFF;", value: "ÿ" },
  { code: "&#x2019;", value: "'" },
  { code: "&apos;", value: "'" },
  { code: "&#x20AC;", value: "€" },
  { code: "&#39;", value: "'" },

  // HEX

  { code: "%20", value: " " },
  { code: "%21", value: "!" },
  { code: "%22", value: '"' },
  { code: "%23", value: "#" },
  { code: "%24", value: "$" },
  { code: "%25", value: "%" },
  { code: "%26", value: "&" },
  { code: "%27", value: "'" },
  { code: "%28", value: "(" },
  { code: "%29", value: ")" },
  { code: "%2A", value: "*" },
  { code: "%2B", value: "+" },
  { code: "%2C", value: "," },
  { code: "%2D", value: "-" },
  { code: "%2E", value: "." },
  { code: "%2F", value: "/" },
  { code: "%30", value: "0" },
  { code: "%31", value: "1" },
  { code: "%32", value: "2" },
  { code: "%33", value: "3" },
  { code: "%34", value: "4" },
  { code: "%35", value: "5" },
  { code: "%36", value: "6" },
  { code: "%37", value: "7" },
  { code: "%38", value: "8" },
  { code: "%39", value: "9" },
  { code: "%3A", value: ":" },
  { code: "%3B", value: ";" },
  { code: "%3C", value: "<" },
  { code: "%3D", value: "=" },
  { code: "%3E", value: ">" },
  { code: "%3F", value: "?" },
  { code: "%40", value: "@" },
  { code: "%41", value: "A" },
  { code: "%42", value: "B" },
  { code: "%43", value: "C" },
  { code: "%44", value: "D" },
  { code: "%45", value: "E" },
  { code: "%46", value: "F" },
  { code: "%47", value: "G" },
  { code: "%48", value: "H" },
  { code: "%49", value: "I" },
  { code: "%4A", value: "J" },
  { code: "%4B", value: "K" },
  { code: "%4C", value: "L" },
  { code: "%4D", value: "M" },
  { code: "%4E", value: "N" },
  { code: "%4F", value: "O" },
  { code: "%50", value: "P" },
  { code: "%51", value: "Q" },
  { code: "%52", value: "R" },
  { code: "%53", value: "S" },
  { code: "%54", value: "T" },
  { code: "%55", value: "U" },
  { code: "%56", value: "V" },
  { code: "%57", value: "W" },
  { code: "%58", value: "X" },
  { code: "%59", value: "Y" },
  { code: "%5A", value: "Z" },
  { code: "%5B", value: "[" },
  { code: "%5C", value: "\\" },
  { code: "%5D", value: "]" },
  { code: "%5E", value: "^" },
  { code: "%5F", value: "_" },
  { code: "%60", value: "`" },
  { code: "%61", value: "a" },
  { code: "%62", value: "b" },
  { code: "%63", value: "c" },
  { code: "%64", value: "d" },
  { code: "%65", value: "e" },
  { code: "%66", value: "f" },
  { code: "%67", value: "g" },
  { code: "%68", value: "h" },
  { code: "%69", value: "i" },
  { code: "%6A", value: "j" },
  { code: "%6B", value: "k" },
  { code: "%6C", value: "l" },
  { code: "%6D", value: "m" },
  { code: "%6E", value: "n" },
  { code: "%6F", value: "o" },
  { code: "%70", value: "p" },
  { code: "%71", value: "q" },
  { code: "%72", value: "r" },
  { code: "%73", value: "s" },
  { code: "%74", value: "t" },
  { code: "%75", value: "u" },
  { code: "%76", value: "v" },
  { code: "%77", value: "w" },
  { code: "%78", value: "x" },
  { code: "%79", value: "y" },
  { code: "%7A", value: "z" },
  { code: "%7B", value: "{" },
  { code: "%7C", value: "|" },
  { code: "%7D", value: "}" },
  { code: "%7E", value: "~" },
  { code: "%7F", value: "" },

  { code: "%C3%A9", value: "é" },
  { code: "%C3%A8", value: "è" },
  { code: "%C3%AA", value: "ê" },
  { code: "%C3%A0", value: "à" },

  { code: "&nbsp;", value: " ", docx: "<w:br/>" },
  { code: "&Agrave;", value: "À" },
  { code: "&agrave;", value: "à" },
  { value: "Â", code: "&Acirc;" },
  { value: "â", code: "&acirc;" },
  { value: "Ç", code: "&Ccedil;" },
  { value: "ç", code: "&ccedil;" },
  { value: "È", code: "&Egrave;" },
  { value: "è", code: "&egrave;" },
  { value: "É", code: "&Eacute;" },
  { value: "é", code: "&eacute;" },
  { value: "Ê", code: "&Ecirc;" },
  { value: "ê", code: "&ecirc;" },
  { value: "Ë", code: "&Euml;" },
  { value: "ë", code: "&euml;" },
  { value: "Î", code: "&Icirc;" },
  { value: "î", code: "&icirc;" },
  { value: "Ï", code: "&Iuml;" },
  { value: "ï", code: "&iuml;" },
  { value: "Ô", code: "&Ocirc;" },
  { value: "ô", code: "&ocirc;" },
  { value: "Œ", code: "&OElig;" },
  { value: "œ", code: "&oelig;" },
  { value: "Ù", code: "&Ugrave;" },
  { value: "ù", code: "&ugrave;" },
  { value: "Û", code: "&Ucirc;" },
  { value: "û", code: "&ucirc;" },
  { value: "Ü", code: "&Uuml;" },
  { value: "ü", code: "&uuml;" },
  { value: "Ÿ", code: "&#376;" },
  { value: "ÿ", code: "&yuml;" },
  { value: "'", code: "&rsquo;" },

  { code: "&lt;", value: "<", after: 1 },
  { code: "&gt;", value: ">", after: 1 },
  { code: "&laquo;", value: "«" },
  { code: "&rdquo;", value: "»" },
  { code: "&raquo;", value: "»" },
  { code: "&ldquo;", value: "«" },
  { code: "&quot;", value: '"' },
  { code: "&forall;", value: "∀" },
  { code: "&sum;", value: "∑" },
  { code: "&euro;", value: "€" },
  { code: "&bull;", value: "•" },
  { code: "&#8226;", value: "•" },

  { code: "&radic;", value: "√" },
  { code: "&hellip;", value: "…" },
  { code: "&rarr;", value: "→" },
  { code: "&larr;", value: "←" },
  { code: "&darr;", value: "?" },

  { value: "∀", code: "&forall;" },
  { value: "∂", code: "&part;" },
  { value: "∃", code: "&exist;" },
  { value: "∅", code: "&empty;" },
  { value: "∇", code: "&nabla;" },
  { value: "∈", code: "&isin;" },
  { value: "∉", code: "&notin;" },
  { value: "∋", code: "&ni;" },
  { value: "∏", code: "&prod;" },
  { value: "∑", code: "&sum;" },
  { value: "−", code: "&minus;" },
  { value: "∗", code: "&lowast;" },
  { value: "√", code: "&radic;" },
  { value: "∝", code: "&prop;" },
  { value: "∞", code: "&infin;" },
  { value: "∠", code: "&ang;" },
  { value: "∧", code: "&and;" },
  { value: "∨", code: "&or;" },
  { value: "∩", code: "&cap;" },
  { value: "∪", code: "&cup;" },
  { value: "∫", code: "&int;" },
  { value: "∴", code: "&there4;" },
  { value: "∼", code: "&sim;" },
  { value: "≅", code: "&cong;" },
  { value: "≈", code: "&asymp;" },
  { value: "≠", code: "&ne;" },
  { value: "≡", code: "&equiv;" },
  { value: "≤", code: "&le;" },
  { value: "≥", code: "&ge;" },
  { value: "⊂", code: "&sub;" },
  { value: "⊃", code: "&sup;" },
  { value: "⊄", code: "&nsub;" },
  { value: "⊆", code: "&sube;" },
  { value: "⊇", code: "&supe;" },
  { value: "⊕", code: "&oplus;" },
  { value: "⊗", code: "&otimes;" },
  { value: "⊥", code: "&perp;" },
  { value: "⋅", code: "&sdot;" },
];
